import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { AnomalyAlertResult, QueryTrigger } from "@app2/clients/types/alert-typedefs";
import { SavedQueryService } from "@app2/search/saved-query.service";
import { SavedQuery } from "@app2/type-defs/search/search-types";
import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { queryStringForAlertResult } from "../alert-inbox/utils";

@Component({
    selector: "anomaly-counts",
    template: `
        <search-link [queryString]="queryStringForAlertResult(trigger, savedQuery$ | async, alert)"
                     [begin]="alert.anomalyTimestamp"
                     [end]="alert.anomalyEndTimestamp"
                     [defaultText]="false"
                     [newTab]="true"
                     [matTooltip]="'INBOX_VIEW_EVENTS' | localize">
            {{ alert.actual }}
        </search-link>
        {{ "VERSUS" | localize }} {{ alert.expected }}
    `,
})
export class AnomalyCountsComponent implements OnChanges {
    @Input() trigger: QueryTrigger;
    @Input() alert: AnomalyAlertResult;

    savedQuery$: Observable<SavedQuery>;

    constructor(private readonly savedQueryService: SavedQueryService) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.trigger) {
            this.savedQuery$ = this.trigger?.savedQueryId
                ? this.savedQueryService.getSavedQuery$(this.trigger.savedQueryId)
                    .pipe(shareReplay(1))
                : null;
        }
    }

    queryStringForAlertResult = queryStringForAlertResult;
}
